import(/* webpackMode: "eager", webpackExports: ["ModuleProgressTracker"] */ "/vercel/path0/ui/app/modules/[slug]/ModuleProgressTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModuleShareButton"] */ "/vercel/path0/ui/app/modules/[slug]/ModuleShareButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModuleNavigation"] */ "/vercel/path0/ui/components/ModuleNavigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModuleViewer"] */ "/vercel/path0/ui/components/ModuleViewer.tsx");
